'use client';
import type { OurBackgroundType } from './data';

import { Container, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import LiaLogo from '@/svgs/aboutUs/liaLogo.svg';

const OurBackground: OurBackgroundType = () => {
  const { t } = useTranslation('pages.aboutUs');

  return (
    <Container>
      <Stack justify="center" align="center" flexDir="column" gap={10}>
        <LiaLogo />
        <Text fontSize={{ base: '2xl', md: '34px' }} fontWeight={500}>
          {t('ourHistory')}
        </Text>
        <Text
          fontSize={{ base: 'xs', md: 'lg' }}
          maxW={1000}
          textAlign="center"
          mx={{ base: 2, md: 0 }}
          lineHeight={{ base: 8, md: 2 }}
        >
          {t('ourHistoryDescription')}
        </Text>
      </Stack>
    </Container>
  );
};

export default OurBackground;
